// Tiny CSV export helper — used by Companies, Users, Partnerships, Reports
// columns: [{ key, label, get?(row) }]  — if `get` not provided, falls back to row[key]
export function exportRowsAsCsv(rows, columns, filename) {
  const esc = (v) => {
    if (v === null || v === undefined) return ''
    const s = String(v)
    if (s.includes('"') || s.includes(',') || s.includes('\n')) {
      return '"' + s.replace(/"/g, '""') + '"'
    }
    return s
  }
  const header = columns.map((c) => esc(c.label)).join(',')
  const body = rows
    .map((r) =>
      columns
        .map((c) => esc(typeof c.get === 'function' ? c.get(r) : r[c.key]))
        .join(',')
    )
    .join('\n')
  const csv = header + '\n' + body
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  const stamp = new Date().toISOString().slice(0, 10)
  a.download = `${filename}-${stamp}.csv`
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
